import type { QuoteRow } from "../../lib/api";

export type SortKey = "apy" | "exit" | "asset";

export function compareBy(key: SortKey): (a: QuoteRow, b: QuoteRow) => number {
	switch (key) {
		case "apy":
			return (a, b) => Number(b.expectedNetApy) - Number(a.expectedNetApy);
		case "exit":
			return (a, b) => a.exitTimeDays - b.exitTimeDays;
		case "asset":
			return (a, b) => a.assetId.localeCompare(b.assetId);
	}
}
